// extracted by mini-css-extract-plugin
export default {"mark":"McpBrandMark_mark__WNnDL","sm":"McpBrandMark_sm__vk1O3","md":"McpBrandMark_md__whpLK","lg":"McpBrandMark_lg__vQUhb"};